<template>
  <section class="block-launch">
    <div class="l-grid">
      <div
        v-if="title"
        class="block-launch__title">
        {{ title }}
      </div>
      <div
        v-if="description"
        class="block-launch__description"
        v-html="description" />
      <div
        v-if="link"
        class="block-launch__link">
        <cta
          v-if="link"
          data-anime
          variant="text"
          :text="link.label ?? $t('actions.discover')"
          v-bind="linkAttrs(link) ?? {}"
          @click="onclick">
          {{ link.label ?? $t("actions.discover") }}
        </cta>
      </div>
    </div>

    <teleport to="body">
      <base-modal
        :show="modal"
        @close="modal = false">
        <template #default>
          <form-builder
            :id="`${formHandle}--form`"
            class="block-launch__form"
            :handle="formHandle"
            :params="formParams"
            @submitted="modal = false" />
        </template>
      </base-modal>
    </teleport>
  </section>
</template>

<script setup>
  const props = defineProps({
    title: String,
    description: String,
    formParams: Array,
    link: {
      type: Object
    }
  })

  const modal = ref(false)
  const formHandle = computed(() => {
    return props.link && props.link?.form ? props.link?.form?.handle : null
  })

  const onclick = () => {
    if (!props.link?.form) return
    modal.value = true
  }
</script>

<style lang="scss" scoped>
.block-launch {
  width: 100%;

  @include blocks-y-spacing;

  text-align: center;

  &__description {
    @include title-l;

    font-size: rem(22px);

    @include mq(xlarge) {
      @include title-l;
    }
  }

  &__title,
  &__description,
  &__link {
    grid-column: 1 / span 12;

    @include mq(medium) {
      grid-column: 2 / span 10;
    }
  }

  &__link {
    padding-top: rem(24px);
  }

  &__form {
    max-width: rem(900px);
    padding: rem(32px);
  }

  &__form :deep(.form-loader__field .cta[type="submit"]) {
    background-color: var(--color-red);
  }
}
</style>
